function useEmployeeSalaryTax() {
  return {};
}

export default useEmployeeSalaryTax;
